module.exports = __webpack_public_path__ + "img/key.e3c0b9b6.svg";